<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>-->
    <router-view />
  </div>
</template>

<script>
import Vue from "vue";
import "ress";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  faInstagram,
  faTwitter,
  faSoundcloud,
  faYoutube
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faEnvelope, faInstagram, faTwitter, faSoundcloud, faYoutube);

Vue.component("font-awesome-icon", FontAwesomeIcon);

export default {};
</script>

<style lang="scss">
$color-black: #0c0c0c;

:root {
  background-color: $color-black;
  font-family: "Russo One", "Audiowide", "游ゴシック", "Yu Gothic", YuGothic,
    /* "Hiragino Kaku Gothic ProN", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, "ＭＳ ゴシック", */
      cursive,
    "sans-serif";

  ::selection {
    color: #fff;
    background: #d1bc21;
  }
}
</style>
